/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { ArrayConfiguration } from '../models/array-configuration';
import { CurrencyRestrictionType } from '../models/currency-restriction-type';
import { DateRestrictionType } from '../models/date-restriction-type';
import { DateSpecificityType } from '../models/date-specificity-type';
import { FieldDefinitionOption } from '../models/field-definition-option';
import { FormFieldType } from '../models/form-field-type';
import { FormInitialisationParameter } from '../models/form-initialisation-parameter';
import { FormJsonDefinition } from '../models/form-json-definition';
import { LookupContextMode } from '../models/lookup-context-mode';
import { LookupCreationMode } from '../models/lookup-creation-mode';
import { LookupDefault } from '../models/lookup-default';
import { LookupResultsMode } from '../models/lookup-results-mode';
import { LookupSourceDefinition } from '../models/lookup-source-definition';
import { LookupStyle } from '../models/lookup-style';
import { PiiType } from '../models/pii-type';
import { SelectApiSource } from '../models/select-api-source';
import { SummaryLevel } from '../models/summary-level';
import { TagCategory } from '../models/tag-category';

/**
 * A field in a FormData schema
 */
export interface FieldDefinition {

  /**
   * If the value is belong to an answerSet then what code it will be
   */
  answerSetCode?: string | null;
  arrayConfiguration?: ArrayConfiguration;

  /**
   * Name of the Form Type used for creation of "new" records
   */
  childFormType?: string | null;

  /**
   * Array child type schema
   */
  childSchema?: Array<FieldDefinition> | null;

  /**
   * When the context is a select value, what type of select value is it?
   */
  contextualType?: string | null;

  /**
   * Either the value or the name of the field that supplies the contextual value for this picklist.
   * Literal values are e.g. "TEAM", vs name of the field prefixed with @-sign e.g. "@ClientType".
   */
  contextualValues?: Array<string> | null;
  currencyRestrictionType?: CurrencyRestrictionType;

  /**
   * If supplied, posting a file needs to use this endpoint instead of POST ../file
   */
  customEndpoint?: string | null;

  /**
   * For file uploads that need custom headers, these will be added to the request when uploading the file.
   */
  customHeaders?: Array<string> | null;
  dateRestrictionType?: DateRestrictionType;
  dateSpecificityType?: DateSpecificityType;

  /**
   * Default Value
   */
  defaultValue?: any | null;

  /**
   * For Files, this links to the expected Document Category is specified
   */
  documentCategory?: string | null;
  fieldType?: FormFieldType;

  /**
   * For image and document fields, what formats are expected
   */
  formatsAccepted?: string | null;
  initialisationParameters?: Array<FormInitialisationParameter> | null;

  /**
   * English description for an input mask
   */
  inputMaskDescription?: string | null;

  /**
   * Reg ex to use as input mask
   */
  inputMaskRegEx?: string | null;

  /**
   * Is this field encrypted?
   */
  isEncrypted?: boolean | null;

  /**
   * Is this field exclusive (for sub-items).
   * An exclusive boolean field will only allow one sub-item to be true.
   * An exclusive select field will only allow one sub-item to have a particular value, e.g. only one phone number of type "Home".
   */
  isExclusive?: boolean | null;

  /**
   * Is the field hidden?
   */
  isHidden?: boolean | null;

  /**
   * Is this field obfuscated
   */
  isObfuscated?: boolean | null;

  /**
   * Is this field the primary name field for the entity
   */
  isPrimaryName?: boolean | null;

  /**
   * Is the field read-only?
   */
  isReadOnly?: boolean | null;

  /**
   * Is this field mandatory?
   */
  isRequired?: boolean | null;

  /**
   * Could this field potentially contain sensitive information?
   */
  isSensitive?: boolean | null;

  /**
   * Is this field sortable (for sub-items)
   */
  isSortable?: boolean | null;
  jsonDefinition?: FormJsonDefinition;
  lookupContextMode?: LookupContextMode;
  lookupCreationMode?: LookupCreationMode;
  lookupDefaultValue?: LookupDefault;
  lookupResultsMode?: LookupResultsMode;

  /**
   * For lookup - what is the source
   */
  lookupSources?: Array<LookupSourceDefinition> | null;
  lookupStyle?: LookupStyle;

  /**
   * For Arrays - maximum number that can be entered, for Numbers and Currency the maximum value
   */
  max?: number | null;

  /**
   * For Arrays - minimum number that must be entered, for Numbers and Currency the minimum value
   */
  min?: number | null;

  /**
   * Minimum number of characters required for searching
   */
  minimumSearchCharacters?: number | null;

  /**
   * Unique Identifier for this field - this is the json field name and the c# property name
   */
  name?: string | null;

  /**
   * List of valid values
   */
  options?: Array<FieldDefinitionOption> | null;
  piiType?: PiiType;

  /**
   * Placeholder text
   */
  placeholder?: string | null;

  /**
   * Previously used tags for the category and entity
   */
  previousTags?: Array<string> | null;

  /**
   * The form to be opened if using Quick Create (for lookups)
   */
  quickCreateFormName?: string | null;
  selectSource?: SelectApiSource;

  /**
   * This defines the type of the select. The front end will pass it back to us when providing contextual values.
   * This is required because it the SelectSource is not filled in (e.g. for an enum or answerset), they don't know what type it is.
   */
  selectType?: string | null;

  /**
   * Should we validate the selected option?
   * Useful to disable if the options are dynamically generated.
   */
  shouldValidateOptions?: boolean;

  /**
   * Should enum options be sorted alphabetically, or preserve the enum order
   */
  sortOptionsAlphabetically?: boolean;

  /**
   * Icon to display with summary
   */
  summaryIcon?: string | null;
  summaryBadgeLabel?: string | null;
  summaryBadgeColour?: string | null;
  summaryLevel?: SummaryLevel;
  tagCategory?: TagCategory;
}

export class FieldDefinition {
  answerSetCode?: string | null;
  arrayConfiguration?: ArrayConfiguration;
  childFormType?: string | null;
  childSchema?: FieldDefinition[] | null;
  contextualType?: string | null;
  contextualValues?: string[] | null;
  currencyRestrictionType?: CurrencyRestrictionType;
  customEndpoint?: string | null;
  customHeaders?: string[] | null;
  dateRestrictionType?: DateRestrictionType;
  dateSpecificityType?: DateSpecificityType;
  defaultValue?: any | null;
  documentCategory?: string | null;
  fieldType?: FormFieldType;
  formatsAccepted?: string | null;
  initialisationParameters?: FormInitialisationParameter[] | null;
  inputMaskDescription?: string | null;
  inputMaskRegEx?: string | null;
  isEncrypted?: boolean | null;
  isExclusive?: boolean | null;
  isHidden?: boolean | null;
  isObfuscated?: boolean | null;
  isPrimaryName?: boolean | null;
  isReadOnly?: boolean | null;
  isRequired?: boolean | null;
  isSensitive?: boolean | null;
  isSortable?: boolean | null;
  jsonDefinition?: FormJsonDefinition;
  lookupContextMode?: LookupContextMode;
  lookupCreationMode?: LookupCreationMode;
  lookupDefaultValue?: LookupDefault;
  lookupResultsMode?: LookupResultsMode;
  lookupSources?: LookupSourceDefinition[] | null;
  lookupStyle?: LookupStyle;
  max?: number | null;
  min?: number | null;
  minimumSearchCharacters?: number | null;
  name?: string | null;
  options?: FieldDefinitionOption[] | null;
  piiType?: PiiType;
  placeholder?: string | null;
  previousTags?: string[] | null;
  quickCreateFormName?: string | null;
  selectSource?: SelectApiSource;
  selectType?: string | null;
  shouldValidateOptions?: boolean;
  sortOptionsAlphabetically?: boolean;
  summaryIcon?: string | null;
  summaryBadgeLabel?: string | null;
  summaryBadgeColour?: string | null;
  summaryLevel?: SummaryLevel;
  tagCategory?: TagCategory;

  constructor(value: FieldDefinition) {
    this.answerSetCode = value?.answerSetCode;
    this.arrayConfiguration = value?.arrayConfiguration ? new ArrayConfiguration(value.arrayConfiguration) : undefined;
    this.childFormType = value?.childFormType;
    this.childSchema = value?.childSchema?.map((x) => new FieldDefinition(x));
    this.contextualType = value?.contextualType;
    this.contextualValues = value?.contextualValues;
    this.currencyRestrictionType = value?.currencyRestrictionType ? Object.entries(Object.values(CurrencyRestrictionType)).flatMap((x) => x).find(x => x === value.currencyRestrictionType) as CurrencyRestrictionType : undefined;
    this.customEndpoint = value?.customEndpoint;
    this.customHeaders = value?.customHeaders;
    this.dateRestrictionType = value?.dateRestrictionType ? Object.entries(Object.values(DateRestrictionType)).flatMap((x) => x).find(x => x === value.dateRestrictionType) as DateRestrictionType : undefined;
    this.dateSpecificityType = value?.dateSpecificityType ? Object.entries(Object.values(DateSpecificityType)).flatMap((x) => x).find(x => x === value.dateSpecificityType) as DateSpecificityType : undefined;
    this.defaultValue = value?.defaultValue;
    this.documentCategory = value?.documentCategory;
    this.fieldType = value?.fieldType ? Object.entries(Object.values(FormFieldType)).flatMap((x) => x).find(x => x === value.fieldType) as FormFieldType : undefined;
    this.formatsAccepted = value?.formatsAccepted;
    this.initialisationParameters = value?.initialisationParameters?.map((x) => new FormInitialisationParameter(x));
    this.inputMaskDescription = value?.inputMaskDescription;
    this.inputMaskRegEx = value?.inputMaskRegEx;
    this.isEncrypted = value?.isEncrypted;
    this.isExclusive = value?.isExclusive;
    this.isHidden = value?.isHidden;
    this.isObfuscated = value?.isObfuscated;
    this.isPrimaryName = value?.isPrimaryName;
    this.isReadOnly = value?.isReadOnly;
    this.isRequired = value?.isRequired;
    this.isSensitive = value?.isSensitive;
    this.isSortable = value?.isSortable;
    this.jsonDefinition = value?.jsonDefinition ? new FormJsonDefinition(value.jsonDefinition) : undefined;
    this.lookupContextMode = value?.lookupContextMode ? Object.entries(Object.values(LookupContextMode)).flatMap((x) => x).find(x => x === value.lookupContextMode) as LookupContextMode : undefined;
    this.lookupCreationMode = value?.lookupCreationMode ? Object.entries(Object.values(LookupCreationMode)).flatMap((x) => x).find(x => x === value.lookupCreationMode) as LookupCreationMode : undefined;
    this.lookupDefaultValue = value?.lookupDefaultValue ? Object.entries(Object.values(LookupDefault)).flatMap((x) => x).find(x => x === value.lookupDefaultValue) as LookupDefault : undefined;
    this.lookupResultsMode = value?.lookupResultsMode ? Object.entries(Object.values(LookupResultsMode)).flatMap((x) => x).find(x => x === value.lookupResultsMode) as LookupResultsMode : undefined;
    this.lookupSources = value?.lookupSources?.map((x) => new LookupSourceDefinition(x));
    this.lookupStyle = value?.lookupStyle ? Object.entries(Object.values(LookupStyle)).flatMap((x) => x).find(x => x === value.lookupStyle) as LookupStyle : undefined;
    this.max = value?.max;
    this.min = value?.min;
    this.minimumSearchCharacters = value?.minimumSearchCharacters;
    this.name = value?.name;
    this.options = value?.options?.map((x) => new FieldDefinitionOption(x));
    this.piiType = value?.piiType ? Object.entries(Object.values(PiiType)).flatMap((x) => x).find(x => x === value.piiType) as PiiType : undefined;
    this.placeholder = value?.placeholder;
    this.previousTags = value?.previousTags;
    this.quickCreateFormName = value?.quickCreateFormName;
    this.selectSource = value?.selectSource ? Object.entries(Object.values(SelectApiSource)).flatMap((x) => x).find(x => x === value.selectSource) as SelectApiSource : undefined;
    this.selectType = value?.selectType;
    this.shouldValidateOptions = value?.shouldValidateOptions;
    this.sortOptionsAlphabetically = value?.sortOptionsAlphabetically;
    this.summaryIcon = value?.summaryIcon;
    this.summaryBadgeLabel = value?.summaryBadgeLabel;
    this.summaryBadgeColour = value?.summaryBadgeColour;
    this.summaryLevel = value?.summaryLevel ? Object.entries(Object.values(SummaryLevel)).flatMap((x) => x).find(x => x === value.summaryLevel) as SummaryLevel : undefined;
    this.tagCategory = value?.tagCategory ? Object.entries(Object.values(TagCategory)).flatMap((x) => x).find(x => x === value.tagCategory) as TagCategory : undefined;
  }
}
